import { isPayment } from './typeGuards';
import { IPayment, IPaymentHistory, PaymentDetail, IGetPaymentHistoryArgs, IGetPaymentDetailArgs } from './types';
import api from '../api/slice';

const paymentApi = api.injectEndpoints({
  endpoints: builder => ({
    getPaymentHistory: builder.query<IPayment[], IGetPaymentHistoryArgs>({
      query: ({ appId, page }) => `${appId}/payment?page=${page}`,
      transformResponse: (paymentHistory: IPaymentHistory) =>
        paymentHistory?.Items?.filter((payment: IPayment) => isPayment(payment) && payment.Status === 'FINALIZED'),
    }),
    getPaymentDetail: builder.query<PaymentDetail, IGetPaymentDetailArgs>({
      query: ({ appId, paymentId }) => `${appId}/payment/${paymentId}`,
    }),
  }),
});

export const {
  useGetPaymentHistoryQuery,
  useGetPaymentDetailQuery,
  useLazyGetPaymentDetailQuery,
  useLazyGetPaymentHistoryQuery,
} = paymentApi;
export default paymentApi;
